<template>
    <div>
        <div class=" about">
                <h2 class="w-100 section-header sticky-top">About</h2> 
              
                <div class="about-card ">

                  <p>
                   I'm a Frontend web developer based in the UK, working with different web technologies to build projects i find intresting and having direct impact on people, while following best practices applicable. I'm capable of learning and working with new technologies swiftly.
                  </p>
                  <p>
                     Most of my time is spent on learning new technologies in the web to build awesome stuffs.
                  </p>
                  <p>
                    Outside being a techy, I hangout with few friends and try not to be an introvert in reality while being social on social media, 😊.     
                  </p>


                </div>             

            </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>
.about{
  margin-top: 90px;
}
.about-card{
    padding: 40px;
    background-color: rgba(32,32,34,var(--bg-opacity));
    transition: all .3s ease;
    margin-bottom: 10px;
    margin: 5px;
    font-size: 18px;
}


</style>